<template>
  <div class="mt-3 mx-3">
    <b-row>
      <b-col sm="12" md="12" lg="6" class="mx-auto">
        <p class="border-bottom font-weight-bold text-center mb-2 pb-3"><span v-if="live_cart.products && live_cart.products.length">{{ live_cart.products.length }}</span> {{ live_cart.products.length === 1 ? $t('product added to shopping cart') : $t('products added to shopping cart') }}</p>

        <div class="cs-product-main-container">
          <div v-for="(product, p_index) in live_cart.products" :key="p_index">
            <div class="card1 card align-items-center border-bottom mx-0" style="max-width: 540px;">
              <img :src="setImage(product.images)" class="card-img" alt="Image" />
              <div class="card-body">
                <strong class="card-title">{{ product.name }}</strong>
                <p class="mb-1">
                  <small class="font-16 font-italic" v-if="product">{{setCurrency(product.net_price_with_rc)}}</small> <b> x </b> <small class="font-16">{{product.line_item.quantity}} {{ $t('unit') }} </small>
                </p>
                <p class="mb-1">
                  <span class="font-16 font-weight-bold">{{$t('Total')}} : </span><small class="font-16 font-italic font-weight-bold pricedata" v-if="product">{{ setCurrency(product.net_price_with_rc * product.line_item.quantity) }}</small>
                </p>
                <p class="clearfix mb-1">
                  <span class="rc-label" v-if="product.is_recycled == '0'"><img class="rc-icon" src="../../public/images/recycling_icon.png" /><span class="rc-label-span">{{ $t('Recycling fee included') }}</span></span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col sm="12" md="12" lg="6" class="mx-auto">
        <p class="border-bottom font-weight-bold text-center mb-2 pb-3">{{ $t('The contents of the shopping cart') }}</p>
        <div class="card align-items-center border-0 ck-details m-0">
            <div class="card-body py-5">
              <b-row>
                <b-col class="font-weight-bold">
                  <span v-if="live_cart.products && live_cart.products.length">{{ live_cart.products.length }}</span> {{ live_cart.products.length === 1 ? $t('product in the shopping cart') : $t('products in the shopping cart') }}
                </b-col>
              </b-row>
              <b-row v-if="live_cart.totals" class="font-14 mt-1">
                <b-col cols="8">{{ $t('Products together') }}</b-col>
                <b-col class="text-right"><span v-if="live_cart.product" v-html="setCurrency(products_sub_total())"></span></b-col>
              </b-row>
              <div v-if="live_cart.services">
                <p class="font-16 my-2 font-weight-bold">{{ $t("Services") }}</p>
                <b-row v-for="(service, s_i) in live_cart.services"  :key="s_i">
                  <b-col class="service-border-bottom font-14">
                    <p class="m-0"> {{ service.name }} {{ service.size }}<span v-if="service.rim_size_id">&Prime;</span></p>
                    <p class="m-0">
                      <span v-html="setCurrency(service.price)"></span> <b class="pl-1">x</b> {{ service.line_item.quantity}} {{ $t('unit') }}
                      <span class="mb-0 font-weight-light text-right float-right"> {{ setCurrency(service.sub_total) }}</span>
                    </p>
                  </b-col>
                </b-row>
              </div>
              <b-row v-if="live_cart.shipping_charges >=0" class="font-14 mt-1">
                <b-col cols="8">{{ $t('Shipping charges') }}</b-col>
                <b-col class="text-right"><span v-html="setCurrency(live_cart.shipping_charges || '0.00')"></span></b-col>
              </b-row>
              <b-row v-if="live_cart.totals" class="mt-2 font-16">
                <b-col cols="8" class="font-weight-bold">{{ $t('Total sum incl. VAT') }}</b-col>
                <b-col class="text-right font-weight-bold"><span v-html="setCurrency(live_cart.totals.total)"></span></b-col>
              </b-row>

              <button type="button" class="btn bg-green color-white w-100 d-block py-3 pb-2 mt-4 mb-1 font-18" @click="$router.push({name : 'cart'})">
                <i class="fa fa-shopping-cart"></i> {{ $t('Go to shopping cart') }}
              </button>

              <p class="font-14 font-weight-bold text-center">{{ $t("Discount codes are given on the order page") }}</p>

              <button type="button" class="btn bg-white color-black w-100 d-block py-3 pb-2 mt-4 mb-1 font-18" @click="continue_shopping()">
                <i class="fa fa-angle-double-left"></i> {{ $t('Continue shopping') }}
              </button>
            </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CheckoutOrStayPopup",
  data : function() {
      return {
        moneySign : "€",
        base_url  : process.env.VUE_APP_BASE_URL
      }
  },
  computed: {
    ...mapGetters('cart_right_sidebar', ['cs_loader', 'live_cart']),
  },
  methods: {
    ...mapActions('cart_right_sidebar', ['getLiveCart']),
    setImage(ProductImages) {
      return (ProductImages && ProductImages.length != 0 && ProductImages != null) ? ProductImages[0].image_base_path+ProductImages[0].path:'/images/no-data-found.png'
    },
    setCurrency(total) {
      if (total) {
        total = parseFloat(total).toFixed(2);
      }
      return total.replace(".", ",") + " " + this.moneySign;
    },
    products_sub_total() {
      var total = 0;
      if (this.live_cart && this.live_cart.products) {
        this.live_cart.products.forEach((val) => {
          total += parseFloat(val.net_price_with_rc) * parseFloat(val.line_item.quantity)
        })
      }
      return total.toString();
    },
    continue_shopping() {
      this.$bvModal.hide('got_to_checkout_popup')
      if (this.$route.name === "product-details") {
        this.$router.push(this.go_to_products());
      }
    }
  },
  async mounted() {
    await this.getLiveCart();
  }
}
</script>

<style scoped>
@media screen and (max-width: 567px) {
  .card-text {
    margin-bottom: 0.5em;
  }
}
.card1.card {
  border: 0;
  border-bottom: 1px solid #e2e2e2;
}
.card {
  margin: 5%;
  flex-direction: row;
}
.card-body {
  padding: 0.5em 1em;
}
.card1.card img {
  max-width: 80px;
  border-bottom-left-radius: calc(0.25rem - 1px);
  border-top-left-radius: calc(0.25rem - 1px);
}
.ck-details {
    background: #e3e3e3;
  border-radius: 0;
}
.service-border-bottom {
  border-bottom: #fff 1px solid !important;
}

</style>